module.exports = __webpack_public_path__ + "media/images/flags/ba-7fe38299788abe05b54604c64b21db61.svg";